<script setup lang="ts">
/* LE composant vue-sonner de l'application — monté UNE fois dans App.vue,
 * hors du composant de layout (un layout conditionnel démonterait les toasts
 * en vol). Les messages passent tous par la façade `useToast()`.
 *
 * ⚠️ `vue-sonner/style.css` n'est pas facultatif : en v2 le paquet n'injecte
 * plus son CSS. C'est ici qu'il est importé (et nulle part ailleurs).
 */
import 'vue-sonner/style.css';
import { Toaster as SonnerToaster } from '@/components/ui/sonner';
import { TOAST_DURATION_MS } from '@/composables/useToast';
</script>

<template>
  <SonnerToaster
    position="top-right"
    :duration="TOAST_DURATION_MS"
    :closeButton="true"
    :richColors="true"
  />
</template>

<style>
/* Palette des toasts : mêmes couleurs que le ToastContainer du Nuxt
 * (fond bg-1, liseré teinté à 40 %, texte à la couleur du statut). */
[data-sonner-toaster] {
  --success-bg: var(--bg-1);
  --success-text: var(--st-done);
  --success-border: color-mix(in oklab, var(--st-done) 40%, transparent);
  --error-bg: var(--bg-1);
  --error-text: var(--pri-high);
  --error-border: color-mix(in oklab, var(--pri-high) 40%, transparent);
  /* Succès PARTIEL (`showWarning`) : l'ambre des états « en cours » du portail —
     ni le vert du succès, ni le rouge de l'échec. */
  --warning-bg: var(--bg-1);
  --warning-text: var(--st-progress);
  --warning-border: color-mix(in oklab, var(--st-progress) 40%, transparent);
  --info-bg: var(--bg-1);
  --info-text: var(--text-2);
  --info-border: var(--line-2);
}

/* Un Dialog reka modal pose `pointer-events: none` sur <body> ; sans ceci les toasts ne sont pas
   cliquables et un clic « sur » un toast tombe sur l'overlay (fermeture de la modale). */
[data-sonner-toast] { pointer-events: auto; }
</style>
